import React from 'react';
import styled from 'styled-components';
import { VImage } from '../../style/base.style';
import { whatsapp } from '../../constants/images';

const FloatingButton = styled.a`
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 20px;
  right: 20px;
  background-color: #2ab318;
  color: white;
  border-radius: 50%;
  text-align: center;
  font-size: 30px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  line-height: 60px;
  text-decoration: none;
  transition: background-color 0.2s ease;
  

  &:hover {
    background-color: #128c7e;
  }
`;

interface WhatsAppButtonProps {
  phoneNumber: string; // e.g., "972501234567"
  message?: string; // optional pre-filled message
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({ phoneNumber, message }) => {
  const encodedMessage = message ? `?text=${encodeURIComponent(message)}` : '';
  const link = `https://wa.me/${phoneNumber}${encodedMessage}`;

  return (
    <FloatingButton
      href={link}
      target="_blank"
      rel="noopener noreferrear"
      title="Chat with us on WhatsApp"
    >
      <VImage
      
      $width="50px"
      src={whatsapp}
      style={{ marginTop: '-5px',marginLeft: '2px' }}
      />
    </FloatingButton>
  );
};

export default WhatsAppButton;
